/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * This option will be returned if a booking can be made using Expedia Affiliate Collect.
 * @export
 * @interface AffiliateCollect
 */
export interface AffiliateCollect {
    /**
     * Display name of payment option.
     * @type {string}
     * @memberof AffiliateCollect
     */
    name?: string;
}

/**
 * Check if a given object implements the AffiliateCollect interface.
 */
export function instanceOfAffiliateCollect(value: object): value is AffiliateCollect {
    return true;
}

export function AffiliateCollectFromJSON(json: any): AffiliateCollect {
    return AffiliateCollectFromJSONTyped(json, false);
}

export function AffiliateCollectFromJSONTyped(json: any, ignoreDiscriminator: boolean): AffiliateCollect {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function AffiliateCollectToJSON(json: any): AffiliateCollect {
    return AffiliateCollectToJSONTyped(json, false);
}

export function AffiliateCollectToJSONTyped(value?: AffiliateCollect | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
    };
}

